module.exports = __webpack_public_path__ + "static/media/HeroImage-service.9afa3264.jpg";